import { EmailInput } from './inputs/EmailInput';
import { TextInput } from './inputs/TextInput';
import { SelectInput } from './inputs/SelectInput';
import { DateInput } from './inputs/DateInput';
import { RadioButtons } from './inputs/RadioInput';
import { PasswordInput } from './inputs/PasswordInput';
import { Checkbox } from './inputs/CheckboxInput';
import { TextareaInput } from './inputs/TextareaInput';
import type { FieldType } from '../../types/EvalancheTypes';

// Maps form field types to their respecive components.
export const componentMap = {
  text: TextInput,
  hidden: TextInput,
  select: SelectInput,
  date: DateInput,
  radio: RadioButtons,
  password: PasswordInput,
  form_EMAIL: EmailInput,
  form_EMAIL_CONFIRMATION: EmailInput,
  checkbox: Checkbox,
  textarea: TextareaInput,
};

// Regex to extract how Evalanche sends checked checkboxes default values.
const multiValueRegex = ''; // /((?<=\|)(\w+?)(?=\|))/g

// Builds Formik initialValues object, according to form's fields
export const initialValueMap = (fields?: FieldType[]) => {
  const initialValues: any = {};
  fields?.forEach((field: FieldType) => {
    if (field.name && field.default_value) {
      if ((field.widget_id === 5 || field.widget_id === 32) && field.type === 'checkbox') {
        // because Evalanche returns values presets differently
        // depending on the number of presets there are.
        if (field.default_value.includes('|')) {
          const matched = field.default_value.match(multiValueRegex);
          initialValues[field.name] = matched;
        } else {
          initialValues[field.name] = [field.default_value];
        }
      } else if (field.type === 'date') {
        // TODO: parsing of Evalanche dates was not implemented because we are not
        // sure that it will send it in the same format for all markets.
        // default value is ignored
        initialValues[field.name] = '';
      } else {
        initialValues[field.name] = field.default_value;
      }
    }
  });

  return initialValues;
};
